import { Box } from '@air/zephyr';
import { Document } from '@contentful/rich-text-types';

import { MediaData, SectionData, VideoData } from '~/lib/contentful/custom-types';
import { Video } from '~/old-marketing/components//Video';
import { Container } from '~/old-marketing/components/Container';
import { Section, SECTION_CMS_LINK_CLASS_NAME } from '~/old-marketing/components/sections/Section';
import { SectionContent } from '~/old-marketing/components/sections/SectionContent';
import { SectionFieldTooltip } from '~/old-marketing/components/sections/SectionFieldTooltip';
import { SectionTitle } from '~/old-marketing/components/sections/SectionTitle';
import { usePreviewMode } from '~/providers/PreviewModeProvider';

const TEMPLATE_KEY = 'adobe-splash-text-with-video';

export type AdobeSplashTextWithVideoSectionTemplateProps = {
  backgroundImages?: MediaData[];
  content?: Document;
  id: string;
  label?: string;
  title?: string;
  isSubsection?: boolean;
  subsections?: SectionData[];
  videos?: VideoData[];
};

export const AdobeSplashTextWithVideoSectionTemplate = ({
  content,
  id,
  isSubsection,
  title,
  videos,
}: AdobeSplashTextWithVideoSectionTemplateProps) => {
  const { isPreview } = usePreviewMode();
  const video = videos?.[0];

  return (
    <Section css={{ paddingY: 80 }} id={id} templateKey={TEMPLATE_KEY}>
      <Container>
        <Box tx={{ mb: [80, 156], '&:last-child': { mb: 0 } }}>
          {title && (
            <SectionTitle
              css={{
                maxWidth: 464,
                marginBottom: 24,
                marginX: 'auto',
                color: '$jay150',
                textAlign: 'center',

                '@laptop': {
                  marginBottom: 40,
                  marginX: 0,
                  textAlign: 'left',
                },
              }}
              dangerouslySetInnerHTML={{ __html: title }}
              isSubsection={isSubsection}
              size="heading-40"
            />
          )}

          {content && (
            <SectionContent
              content={content}
              css={{
                maxWidth: 560,
                marginBottom: 40,
                marginRight: 'auto',
                marginLeft: 'auto',
                color: '$pigeon200',
                textAlign: 'center',

                '@laptop': {
                  marginRight: 0,
                  textAlign: 'left',
                },
              }}
              size="ui-20"
            />
          )}

          {video && (
            <SectionFieldTooltip field="Videos">
              <Box>
                <Video
                  className={isPreview ? SECTION_CMS_LINK_CLASS_NAME : ''}
                  details={{
                    height: video.height,
                    width: video.width,
                  }}
                  poster={video.poster.file.url}
                  sources={video.types.map((type) => ({
                    src: type.file.url,
                    type: type.file.contentType,
                  }))}
                />
              </Box>
            </SectionFieldTooltip>
          )}
        </Box>
      </Container>
    </Section>
  );
};

AdobeSplashTextWithVideoSectionTemplate.templateKey = TEMPLATE_KEY;
